import { openapi } from "@orpc/openapi";
import { z } from "zod";
import { readContract } from "./errors";
import { publicIdSchema } from "./public-id";

export const ownAccountSchema = z.object({
  public_id: publicIdSchema,
  email: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  phone: z.string().nullable(),
  subscription: z.object({
    planName: z.string().nullable(),
    planStatus: z.string().nullable(),
    periodEnd: z.int().nullable(),
    periodEndCancel: z.int().nullable(),
  }),
  preferences: z.object({
    style: z.string().nullable(),
    format: z.string().nullable(),
    retentionPeriod: z.int().nullable(),
    occupation: z.string(),
    title: z.string(),
    country: z.string().nullable(),
    state: z.string().nullable(),
    city: z.string().nullable(),
    transcriptionLanguageId: z.int(),
    visitRetentionPeriodId: z.int(),
  }),
  // Early-access feature keys granted to this account (see
  // ./early-access). Plain strings so an older client never fails on a key
  // added later; clients keep only the keys they know. A response from an
  // API without the field (an older release) reads as none.
  earlyAccess: z.array(z.string()).default([]),
});

export const accountContract = {
  me: readContract
    .errors({
      UNAUTHORIZED: { message: "Authentication required" },
      FORBIDDEN: { message: "Account required" },
      SERVICE_UNAVAILABLE: { message: "Authentication unavailable" },
    })
    .meta(
      openapi({
        method: "GET",
        path: "/api/v2/me",
        successStatus: 200,
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(ownAccountSchema),
};
